import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  output,
} from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { MatTooltip } from '@angular/material/tooltip';
import { FileService } from '@ipg/ngx-frontend-toolset';
import { AvatarComponent } from '../../../../components/avatar/avatar.component';
import { DataTableContainerComponent } from '../../../../components/data-table-container/data-table-container.component';
import { FilesizePipe } from '../../../../pipes/filesize.pipe';
import {
  SignalingImageBlock,
  SignalingImageBlockData,
} from '../../client-signaling.model';

@Component({
  selector: 'app-signaling-block-image-table',
  imports: [
    MatIcon,
    MatIconButton,
    MatTableModule,
    MatTooltip,
    AvatarComponent,
    DataTableContainerComponent,
    FilesizePipe,
  ],
  templateUrl: './signaling-block-image-table.component.html',
  styleUrl: './signaling-block-image-table.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SignalingBlockImageTableComponent {
  private readonly _file = inject(FileService);

  dataSource = input<SignalingImageBlock['data']>([]);

  hideActions = input(false, { transform: booleanAttribute });

  data = computed(() =>
    this.dataSource().map((value) => this._mapImageBlockData(value))
  );

  displayedColumns = ['name', 'size', 'dimensions', 'actions'];

  itemRemove = output<string>();

  private _mapImageBlockData(block: SignalingImageBlockData) {
    return {
      ...block,
      fileUrl: this._file.get(block.fileId).href,
    };
  }
}
